import { render } from "./TownRead.vue?vue&type=template&id=04f6f50f&scoped=true"
import script from "./TownRead.vue?vue&type=script&lang=js"
export * from "./TownRead.vue?vue&type=script&lang=js"

import "./TownRead.vue?vue&type=style&index=0&id=04f6f50f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f6f50f"]])

export default __exports__